import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { SKIP_LOADER } from './loader.context';

/**
 * HTTP interceptor that shows/hides the global loader for all HTTP requests.
 * Shows loader when request starts, hides when request completes (success or error).
 *
 * To skip the loader for specific requests, use the SKIP_LOADER context token:
 * ```typescript
 * import { SKIP_LOADER } from '@shared/interceptors/loader.context';
 *
 * this.http.get('/api/data', {
 *   context: new HttpContext().set(SKIP_LOADER, true)
 * });
 * ```
 */
export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  // Check if request has skip loader context token
  const skipLoader = req.context.get(SKIP_LOADER);

  if (!skipLoader) {
    loaderService.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipLoader) {
        loaderService.hide();
      }
    })
  )
}
